import axios from '@/utilities/api/axios';
import { app } from '@/main';

export const state = initialState();

export const actions = {
  getTranslatedAppLabels: async ({ commit }, payload) => {
    try {
      const { code } = payload;

      const res = await axios.get(`/languages/${code}`);
      commit('mutateTranslatedAppLabels', { code, labels: res.data.labels });

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  mutateTranslatedAppLabels: (state, payload) => {
    state.appLabels = payload.labels;

    app.$i18n.setLocaleMessage(payload.code, payload.labels);
    app.$i18n.locale = payload.code;
  }
};

export const getters = {};

function initialState() {
  return {
    languages: [],
    appLabels: {},
    filteredLanguages: [
      {
        text: 'English',
        value: 'en',
        flag: `${process.env.BASE_URL}flags/en-flag.png`
      },
      {
        text: 'Italiano',
        value: 'it',
        flag: `${process.env.BASE_URL}flags/it-flag.png`
      },
      {
        text: 'Español',
        value: 'es',
        flag: `${process.env.BASE_URL}flags/es-flag.svg`
      },
      {
        text: '中文',
        value: 'zh',
        flag: `${process.env.BASE_URL}flags/zh-flag.svg`
      }
    ]
  };
}
